'use strict';
/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';



// WEBPACK FOOTER //
// ./~/core-js/internals/engine-is-bun.js